import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Modal } from "semantic-ui-react";
import { Wrapped } from "@components/Layouts";
import { AdminForm } from "@components/Admin";
import { ChangePassword } from "@components/Profile";
import PhoneManagement from "@components/PhoneManagement";
import { Button } from "@components/shared";

export default function Profile() {
  const [profile, setProfile] = useState(populateProfile());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios
      .get(`/admin-profile/`)
      .then(({ data }) => {
        setProfile(populateProfile(data.response[0]));
        setLoading(false);
      })
      .catch((err) => {});
  }

  return (
    <React.Fragment>
      <Wrapped title="Profile">
        <AdminForm
          email={profile.email}
          firstName={profile.firstName}
          id={profile.id}
          isProfile
          lastName={profile.lastName}
          mfa={profile.mfa}
          onSuccess={fetchData}
          phone={profile.phone}
          title={profile.title}
        />
      </Wrapped>
      {!loading && <PhoneManagement adminId={profile.id} />}
      <Wrapped>
        <ChangePw id={profile.id} />
      </Wrapped>
    </React.Fragment>
  );
}

function populateProfile(d) {
  let data = { ...d };
  return {
    email: data.email || "",
    firstName: data.first_name || "",
    id: data.id,
    lastName: data.last_name || "",
    mfa: data.mfa || false,
    phone: data.phone || "",
    title: data.title || "",
  };
}

const ChangePw = ({ id }) => {
  const [isOpen, setOpen] = useState(false);

  function onClose() {
    setOpen(false);
  }

  return (
    <React.Fragment>
      <Button.Basic text="Change Password" onClick={() => setOpen(true)} />
      <Modal open={isOpen} onClose={onClose} size="tiny">
        <Modal.Content>
          <ChangePassword
            adminId={id}
            onSuccess={() => {
              toast.success("Password updated!");
              onClose();
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button.Basic text="Close" onClick={onClose} />
          </div>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  );
};
